import { BalanceHistoryType } from '@/app/shared/types/pages/balance-history';
import { PriceType } from '@app/shared/types/common';

export const BALANCE_HISTORY_TO_FILTERS_MAP: Record<
  BalanceHistoryType,
  { type: PriceType | null }
> = {
  [BalanceHistoryType.COOKIE]: { type: PriceType.COOKIE },
  [BalanceHistoryType.DIAMOND]: { type: PriceType.TON },
  [BalanceHistoryType.UNDEFINED]: { type: null },
};
